import React, { useState } from "react";
import { VStack } from "native-base";
import AVBody from "../../components/common/AVBody";
import { useSelector, RootStateOrAny } from "react-redux";
import _ from "lodash";
import EventsContent from "../../components/Events/EventsContent";

function MyEvents() {
  const user = useSelector((state: RootStateOrAny) => state?.user?.user[0]);
  const [showCreateNewPage, setShowCreateNewPage] = useState<any>(false);
  const [createType, setCreateType] = useState<any>("");
  const [showEdit, setIsShowEdit] = useState(false);
  const [isOpenConvo, setIsOpenConvo] = useState(false);
  const [isConvoData, setIsConvoData] = useState("");

  return (
    <AVBody
      setIsShowEdit={setIsShowEdit}
      isGeneral={undefined}
      setIsGeneral={undefined}
      isRole={undefined}
      setIsRole={undefined}
      Entity={undefined}
      setIsEntity={undefined}
      type={undefined}
      isHomepage={undefined}
      setShowCreateNewPage={setShowCreateNewPage}
      showCreateNewPage={showCreateNewPage}
      setCreateType={setCreateType}
      createType={createType}
      passEntity={undefined}
      isOpenConvo={isOpenConvo}
      setIsConvoData={setIsConvoData}
      isConvoData={isConvoData}
      setPassEntity={undefined}
      setIsOpenConvo={setIsOpenConvo}
      setIshuddleData={undefined}
    >
      <VStack flex={[1, 1, 1, 3]}>
        <EventsContent user={user} />
      </VStack>
    </AVBody>
  );
}



export default MyEvents;